import { slugify } from "healthex-common/utils";
const _patientConsentRoutes = [
    "ENROLLMENT_WELCOME",
    "ENROLLMENT_REQUEST_DETAILS_POPUP",
    "ENROLLMENT_LOGIN",
    "ENROLLMENT_BILL_OF_RIGHTS",
    "ENROLLMENT_STUDY_INFORMATION",
    "ENROLLMENT_CONTACT",
    "ENROLLMENT_BENEFITS",
    "ENROLLMENT_RISKS",
    "ENROLLMENT_CHOICE",
    "ENROLLMENT_DATA_TYPES",
    "ENROLLMENT_DATA_SHARING",
    "ENROLLMENT_CUSTOM_SECTION_1",
    "ENROLLMENT_CUSTOM_SECTION_2",
    "ENROLLMENT_CUSTOM_SECTION_3",
    "ENROLLMENT_CUSTOM_SECTION_4",
    "ENROLLMENT_CUSTOM_SECTION_5",
    "ENROLLMENT_CUSTOM_SECTION_6",
    "ENROLLMENT_CUSTOM_SECTION_7",
    "ENROLLMENT_CUSTOM_SECTION_8",
    "ENROLLMENT_CUSTOM_SECTION_9",
    "ENROLLMENT_CUSTOM_SECTION_10",
    "ENROLLMENT_SENSITIVE_DATA_CONFIRMATION",
    "ENROLLMENT_INFORMED_CONSENT",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_IN_PARTICIPANT_CONSENT_INTERIM_PAGE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_IN_MINOR_CONSENT_INTERIM_PAGE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_IN",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_OUT_INTERIM_PAGE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_OUT",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_IM_INTERESTED_INTERIM_PAGE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_IM_INTERESTED",
    "ENROLLMENT_REAUTHORIZATION",
    "ENROLLMENT_HIPAA_AUTHORIZATION",
    "ENROLLMENT_CONFIRMED",
    "ENROLLMENT_DECLINED",
    "ENROLLMENT_PREREAD_THANKYOU",
    "ENROLLMENT_IM_INTERESTED_THANKYOU",
    "ENROLLMENT_PATIENT_COMPENSATION",
    "ENROLLMENT_EXCLUDED",
    "ENROLLMENT_WELCOME_BACK",
    "ENROLLMENT_PURPOSE_OF_RESEARCH",
    "ENROLLMENT_LENGTH_OF_RESEARCH",
    "ENROLLMENT_HEALTH_RECORD_UPDATES",
    "ENROLLMENT_PROCEDURES_AND_INTERVENTIONS",
    "ENROLLMENT_PARTICIPATION_AND_ACTIVITIES",
    "ENROLLMENT_TIMELINE_OF_VISITS",
    "ENROLLMENT_CONFIDENTIALITY_OF_DATA",
    "ENROLLMENT_INJURY_PROTOCOL",
    "ENROLLMENT_PARTICIPATION_TERMINATION",
    "ENROLLMENT_LEAVING_STUDY_EARLY",
    "ENROLLMENT_COST_OF_PARTICIPATION",
    "ENROLLMENT_SHARING_RESULTS",
    "ENROLLMENT_PROVIDER_AUTHORIZATION",
    "ENROLLMENT_PDDA_RECORD_LOCATION",
    "ENROLLMENT_PDDA_RECORD_LOCATION_SCREENSHOT_REVIEW_AND_SHARE",
    "ENROLLMENT_PARTICIPATION_SIGNATURE",
    "ENROLLMENT_PARTICIPATION_SIGNATURE_SCREENSHOT_PREVIEW_DECLINED",
    "ENROLLMENT_PASS_DEVICE_TO_PARENT_GUARDIAN",
    "ENROLLMENT_PARENT_GUARDIAN_REAUTHORIZATION",
    "ENROLLMENT_PARENT_GUARDIAN_SIGNATURE",
    "ENROLLMENT_PASS_DEVICE_TO_ADDITIONAL_PARENT_GUARDIAN",
    "ENROLLMENT_ADDITIONAL_PARENT_GUARDIAN_REAUTHORIZATION",
    "ENROLLMENT_ADDITIONAL_PARENT_GUARDIAN_SIGNATURE",
    "ENROLLMENT_PASS_DEVICE_TO_MINOR",
    "ENROLLMENT_MINOR_SIGNATURE",
    "ENROLLMENT_PASS_DEVICE_TO_WITNESS",
    "ENROLLMENT_WITNESS_SIGNATURE",
    "ENROLLMENT_PASS_DEVICE_TO_PROVIDER",
    "ENROLLMENT_PROVIDER_AUTHORIZATION",
    "ENROLLMENT_IDENTITY_VERIFIED",
    "ENROLLMENT_DECLINED_ACCESS",
];
export const patientConsentRouteValues = _patientConsentRoutes;
export function patientConsentRouteParts(route) {
    const parts = route.split("_");
    const flow = parts[0];
    const step = slugify(parts.slice(1).join("_"));
    return { flow, step };
}
export function patientConsentRouteFromParts(parts) {
    const { flow, step } = parts;
    if (!step)
        return null;
    const patientConsentManagerRoute = `${flow}_${step}`;
    if (patientConsentRouteValues.includes(patientConsentManagerRoute)) {
        return patientConsentManagerRoute;
    }
    else {
        return null;
    }
}
